export default "__VITE_ASSET__d6240486__"